import config from "../../lib/config"

export default function Envbar (props) {
    return <>
        <div id="envbar" className={config?.app?.env != 'dev' ? 'bg-primary-brand-color' : 'bg-success'}>

        </div>
    </>
}